import { apiProducts } from "./api";

export const saleInProgressService = (params) => {
  return apiProducts.post("/api/sale-in-progress/save", params);
};
